import {eq} from '@shared/helpers/lang'

import {FDS_AUTH_LEVEL, FDSPhase} from '@web/core/constants'
import {FdsState, FDSStatus} from '@web/slices/fds/slice'

const isFDSStarted = eq(FDSPhase.STARTED)
const isFDSNotPending = eq(FDSStatus.PENDING)

export const isFdsInfoValid = (fds: FdsState) => {
    if (!fds.uuid && !fds.options.ignoreUuid) {
        return false
    }

    // fds pending 상태가 아니면 이미 검증이 끝난 단계
    if (!isFDSNotPending(fds.status)) {
        return false
    }

    // fds started 상태 외는 이미 fds 인증단계를 거쳤거나 정보 세팅이 되지 않은 상태
    if (!isFDSStarted(fds.phase)) {
        return false
    }

    // fds 필수적인 정보가 부재한 상태
    if (!fds.authentication) {
        return false
    }

    // 정상적인 fds 레벨정보가 세팅되지 않은 상태
    if (!fds.authentication.level) {
        return false
    }

    // fds 인증창에 제출할 sessionKey 정보가 부재한 상태
    if (fds.authentication.level === FDS_AUTH_LEVEL.PASSWORD && !fds.authentication.sessionKey) {
        return false
    }

    return true
}
